module.exports = __webpack_public_path__ + "static/media/loading.c5704dc4.gif";